module.exports = __webpack_public_path__ + "img/1be18578.png";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/front/img/tsm-full.png
// module id = 378
// module chunks = 14